module.exports = __webpack_public_path__ + "img/title.08c61272.png";